module.exports = __webpack_public_path__ + "img/map-rooms.0ba3c4e9.svg";